import { computed, makeObservable, override } from 'mobx';

import { TAvatarBackgroundColorIndex } from 'APP/components/Avatar/Avatar';
import { IGroupData } from 'APP/model/group/groupModel.types';
import { Root } from 'STORE';
import { Groups } from 'STORE/Groups/Groups';
import { User } from 'STORE/Users/User/User';

import { Group } from '../Group';

export class P2P extends Group {
  constructor(group: IGroupData, groups: Groups, root: Root) {
    super(group, groups, root);
    makeObservable(this);
  }

  get isP2P(): boolean {
    return true;
  }

  get isGroup(): boolean {
    return false;
  }

  get isBot(): boolean {
    return Boolean(this.botOpponentId);
  }

  @override
  get canInviteUsers(): boolean {
    return false;
  }

  @override
  get avatarColorIndex(): TAvatarBackgroundColorIndex {
    if (this.groupOpponent) {
      return this.groupOpponent.avatarColorIndex;
    }
    return '1';
  }

  @override
  get verified(): boolean {
    if (this.groupOpponent) {
      return this.groupOpponent.verified;
    }

    return this._verified;
  }

  @override
  get avatarTitle(): string | null {
    if (this.groupOpponent) {
      return this.groupOpponent.avatarTitle;
    }

    return null;
  }

  @override
  get avatarUrl(): string | null {
    if (this.groupOpponent) {
      return this.groupOpponent.avatarUrl || null;
    }

    return null;
  }

  set avatarUrl(avatarUrl: string | null) {
    this.setAvatarUrl(avatarUrl);
  }

  get groupOpponentId(): string | null {
    return this.opponentId || this.botOpponentId;
  }

  @computed
  get groupOpponent(): User {
    return this.root.usersStore.getUserById(this.groupOpponentId!)!;
  }

  @computed
  get isBlockedMe(): boolean {
    return this.groupOpponent ? this.groupOpponent.isBlockedMe : false;
  }

  @computed
  get isBlockedByMe(): boolean {
    return this.groupOpponent ? this.groupOpponent.isBlockedByMe : false;
  }

  @computed
  get isOnlineOpponent(): boolean {
    if (!this.groupOpponent) {
      return false;
    }

    return this.groupOpponent.isOnline;
  }

  get canMentionAll(): boolean {
    return false;
  }

  get canBeScheduled(): boolean {
    return true;
  }

  @override
  get canLeaveComment(): boolean {
    return false;
  }
}
